import JewelIcon from './Jewel';

export const SkinSeoulHiddenGems = () => {
  return (
    <div
      className="flex items-center justify-center w-full h-fit pt-5 pb-2"
      style={{ background: 'linear-gradient(180deg, rgba(111, 63, 215, 0.00) 0%, rgba(111, 63, 215, 0.40) 100%)' }}
    >
      <div className="flex flex-row items-center gap-2 h-full">
        <div className="w-5 h-5 flex items-center justify-center">
          <JewelIcon />
        </div>

        <span className="text-label-small font-normal text-primary-500 whitespace-nowrap">Hidden Gems</span>
      </div>
    </div>
  );
};

export default SkinSeoulHiddenGems;
